<div [formGroup]="formGroup.form">
  <z-popup-lov
    [list]="customerList$ | async"
    [fieldName]="fieldName"
    [label]="label"
    [placeholder]="placeholder"
    [hint]="hint"
    [buttonAction]="openDialog"
    [readonly]="readonly"
    [disabled]="disabled"
    [uppercase]="uppercase"
    [clearButton]="clearButton"
    [manualInput]="manualInput"
    [enableDropdown]="enableDropdown"
    [showDropdownFilter]="showDropdownFilter"
    [doubleClickToOpenPopup]="doubleClickToOpenPopup"
    (change)="onChangeHandler($event)"
    (clear)="onClearHandler($event)"
  >
  </z-popup-lov>
</div>
